import React from 'react';
import { connect } from 'react-redux';
import i18n from 'utils/I18n';
import { getMaxCashDollar } from 'component/profile/PointAndCashSection';
import BaseLeftSection from './BaseLeftSection';
import { enLocaleNumberFormatter } from 'utils';


const PointWithCashComponent = ({
  language,
  isLogin,
  availablePoints,
}) => {
  if (!isLogin) {
    return null;
  };

  return (
    <div className="header-point-with-cash-container">
      <BaseLeftSection 
        title={i18n.t("points")}
        content={enLocaleNumberFormatter(availablePoints)}
        contentSrc={"/profile/currentPoint/points.png"}
        contentSrcSet={"/profile/currentPoint/points@2x.png 2x, /profile/currentPoint/points@3x.png 3x"}
      />
      <div className='header-point-with-cash-equal subheading'>
        =
      </div>
      <BaseLeftSection 
        title={i18n.t("cash_dollar")}
        content={enLocaleNumberFormatter(getMaxCashDollar(availablePoints))}
        contentSrc={"/profile/currentPoint/cash-dollar.png"}
        contentSrcSet={"/profile/currentPoint/cash-dollar@2x.png 2x, /profile/currentPoint/cash-dollar@3x.png 3x"}
      />
    </div>
  );
};


const mapStateToProps = (state) => ({
  language: state.users.language,
  isLogin: state.users.isLogin,
  availablePoints: state.users.availablePoints,
})


export default connect(mapStateToProps)(PointWithCashComponent);
